import React, { useState, useEffect } from "react";
import "../Pages/CSS/navbar.css";
import Autotype from "./Autotype";

import logo from "../Images/HK.svg";
import linkedin from "../Images/assets/in.svg";
import github from "../Images/assets/github.svg";

function Navbar() {
    const [time, setTime] = useState(new Date().toLocaleTimeString());
  
    
    useEffect(() => {
      const intervalId = setInterval(() => {
        setTime(new Date().toLocaleTimeString());
      }, 1000);
  
      return () => clearInterval(intervalId);
    }, []);

  return (
    <div className="navbar">
      <div className="main-container"> 
        <div className="main_logo-container">
          <img className="main_logo" src={logo} alt=""/>
        </div>
        <Autotype/>
        <div className="time-container">
            <h1 className="time">{time}</h1>
        </div>
        <div className="word-container">
          <a
            href="#about"
            className="cursor-none"
            onClick={e => {
              e.preventDefault();
              const el = document.getElementById("about");
              if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 128;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
          >
            About
          </a>
          <a
            href="#work"
            className="cursor-none"
            onClick={e => {
              e.preventDefault();
              const el = document.getElementById("work");
              if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 128;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
          >
            Work
          </a>
          <a
            href="#connect"
            className="cursor-none"
            onClick={e => {
              e.preventDefault();
              const el = document.getElementById("connect");
              if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 128;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
          >
            Contact
          </a>
        </div>
        <div className="logo-container">
          <a href="https://www.linkedin.com/in/harsh-karanwal-a35b8a175/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img className="logo1" src={linkedin} alt="" />
          </a>
        </div>
        <div className="logo-container">
          <a href="https://github.com/Harsh-af" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <img className="logo2" src={github} alt="" />
          </a>
        </div>
        <div className="text-container">
            <p>
              Available for freelance work → 
              <span
                href="#about"
                className="hire-me"
                onClick={e => {
                  e.preventDefault();
                  const el = document.getElementById("connect");
                  if (el) {
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 128;
                    window.scrollTo({ top: y, behavior: "smooth" });
                  }
                }}
              >
                Hire me
              </span>
            </p>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
